export const Colors = {
    primaryColor: "#041797",
    secondaryColor: "#a5b4d9",
    yellowColor: "#eded00",
    redColor: "#f10005",
    whiteColor: "#ffffff",
    darkColor: "#001529",
}